import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import loading from "../../assets/images/loading.gif";
import { useLocation, useNavigate } from "react-router-dom";
import { getApiUrl, getApiHeaders } from "../../config/api";

const Processing = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMatches = async () => {
      const formData = new FormData();

      // Only append "query" if it contains non-empty text
      if (state.query?.trim()) {
        formData.append("query", state.query);
      }

      // Append the image if it exists
      if (state.selectedImage) {
        formData.append("image", state.selectedImage);
      }

      try {
        const response = await fetch(getApiUrl("match"), {
          method: "POST",
          headers: getApiHeaders(),
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        navigate("/result", { state: { matches: data.matches } });
      } catch (error) {
        console.error("Failed to fetch matches", error);
        navigate("/result", { state: { matches: [] } });
      }
    };

    fetchMatches();
  }, [state, navigate]);

  return (
    <Box
      sx={{
        bgcolor: "#FBFFE9",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <Container
        sx={{
          bgcolor: "#FBFFE9",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            variant="h1"
            color="primary"
            sx={{
              fontFamily: "'Poppins-SemiBold', Helvetica",
              fontWeight: 600,
              fontSize: "39px",
              color: "#516d4f",
            }}
          >
            Finding a match...
          </Typography>
          <img
            src={loading}
            alt="Loading"
            style={{ width: "137px", height: "137px", marginTop: "16px" }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Processing;